<template>
  <div :class="type ? type : 'default'" class="btn">
    <van-icon name="arrow" color="#fff" class="icons" />
  </div>
</template>
<script>
export default {
  name: 'xy-enter',
  props: {
    type: {
      type:String,
      default: 'Default'      
    }
  }
}
</script>
<style lang="less" scoped>
.btn {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;  
  border-radius:50%;
  .icons {
    flex: 1;
    text-align: center;
    font-size: 24px;
  }
}
.default {
  background:rgba(74,152,253,1);
  box-shadow:0px 4px 12px 0px rgba(50,133,255,.4);
}
.disabled {
  background: #dddddd;
  box-shadow:0px 4px 12px 0px rgba(0,0,0,.1);
}
</style>